var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.334 3.25A2.75 2.75 0 0 1 11.084 6c0 .694-.26 1.327-.685 1.81a4.08 4.08 0 0 1 2.019 3.523.75.75 0 0 1-1.5 0 2.584 2.584 0 0 0-5.167 0 .75.75 0 0 1-1.5 0c0-1.501.81-2.813 2.017-3.522A2.74 2.74 0 0 1 5.584 6a2.75 2.75 0 0 1 2.75-2.75m0 1.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.334.583a7.417 7.417 0 1 1-.002 14.834A7.417 7.417 0 0 1 8.334.583m0 1.5a5.917 5.917 0 1 0 0 11.832 5.917 5.917 0 0 0 0-11.832",
    clipRule: "evenodd"
  })));
};
export default Svg16;